const SVGStuff = () => (
  <svg
    width="87"
    height="36"
    viewBox="0 0 87 36"
    fill="none"
    style={{ width: '100%' }}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <title>Stuff.co.nz logo</title>
    <g clipPath="url(#clip0_1761_3481)">
      <path
        d="M15.6988 28.8617C14.1631 30.0584 12.0885 30.6903 9.2865 30.6903C6.14771 30.6903 2.82033 29.7088 0.449402 27.4633L3.00893 23.4295C4.77244 24.8798 6.93078 25.7696 9.20567 25.9842C10.8896 25.9842 12.0885 25.554 12.0885 24.2094C12.0885 22.8513 9.03054 22.1656 8.26269 21.9235C7.45441 21.7084 6.26895 21.3588 5.29903 20.942C4.20338 20.5184 3.26838 19.7626 2.62558 18.7809C1.98279 17.7992 1.66456 16.6411 1.71569 15.4694C1.71569 11.3953 5.28555 8.89433 9.66369 8.89433C14.0418 8.89433 16.507 10.5079 17.6925 11.4894L15.4832 15.4694C13.9525 14.3139 12.1275 13.6104 10.216 13.4391C8.59946 13.4391 7.71037 13.8559 7.71037 14.9585C7.71037 16.0611 9.32691 16.572 10.7683 17.0023C12.2097 17.4191 12.8429 17.6342 13.732 17.9704C14.675 18.3066 15.7392 18.8578 16.4532 19.5436C17.1267 20.2159 18.1505 21.5739 18.1505 23.7791C18.1505 25.9304 17.221 27.6381 15.6988 28.8617M33.831 14.5013H29.1969V22.0042C29.1969 23.7791 29.4663 24.2094 29.8031 24.5858C30.0995 24.922 30.5171 25.0968 31.4196 25.0968C32.4704 25.0968 33.4403 24.7203 33.4403 24.7203L33.7906 30.018C33.2787 30.139 31.4062 30.6903 28.9409 30.6903C26.5161 30.6903 24.9131 29.9643 23.8488 28.7407C22.7846 27.5036 22.367 25.7825 22.367 22.5958V14.5013H19.3899V9.36495H22.3535V3.69072H29.1969V9.36495H33.831V14.5013ZM55.8698 30.2197H49.3498L49.3094 27.8532C48.5762 28.7626 47.6433 29.4915 46.5828 29.9834C45.5223 30.4754 44.3626 30.7172 43.1934 30.6903C40.1759 30.6903 38.263 29.6281 37.1988 28.2297C36.175 26.791 35.6765 24.9623 35.6765 21.9639V9.32461H42.466V21.0226C42.466 23.4429 43.1396 25.0968 45.5644 25.0968C47.9892 25.0968 49.0938 23.1875 49.0938 20.431V9.32461H55.8833V30.2197H55.8698ZM72.3451 5.66729C72.3451 5.66729 71.0384 5.30425 69.8394 5.30425C67.8457 5.30425 67.3338 6.44716 67.3338 8.0069V9.36495H71.8466V14.5013H67.3338V30.2332H60.5039V14.5013H57.8231V9.36495H60.5039V8.22203C60.5039 5.89587 60.9754 3.85208 62.2013 2.5747C63.4272 1.27044 65.4344 0.42334 68.0612 0.42334C70.742 0.42334 72.6953 0.974627 72.6953 0.974627L72.3451 5.68073V5.66729Z"
        fill="black"
      />
      <path
        d="M86.1126 5.66729C86.1126 5.66729 84.7925 5.30425 83.607 5.30425C81.6133 5.30425 81.1014 6.44716 81.1014 8.0069V9.36495H85.6007V14.5013H81.1014V30.2332H74.258V14.5013H71.5907V9.36495H74.258V8.22203C74.258 5.89587 74.7295 3.85208 75.9554 2.5747C77.1947 1.27044 79.1884 0.42334 81.8153 0.42334C84.4961 0.42334 86.4494 0.974627 86.4494 0.974627L86.1126 5.68073V5.66729Z"
        fill="black"
      />
      <path
        d="M0.705383 33.9577H86.3821V35.4233H0.705383V33.9577Z"
        fill="url(#paint0_linear_1761_3481)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1761_3481"
        x1="0.705383"
        y1="34.6914"
        x2="86.3821"
        y2="34.6914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4E00" />
        <stop offset="0.13" stopColor="#FF4E00" />
        <stop offset="0.1323" stopColor="#FF5000" />
        <stop offset="0.1785" stopColor="#FE7F00" />
        <stop offset="0.2228" stopColor="#FCA300" />
        <stop offset="0.2639" stopColor="#FCBD00" />
        <stop offset="0.3009" stopColor="#FBCC00" />
        <stop offset="0.33" stopColor="#FBD200" />
        <stop offset="0.346" stopColor="#EDD107" />
        <stop offset="0.3766" stopColor="#C6CF1B" />
        <stop offset="0.4186" stopColor="#89CC3A" />
        <stop offset="0.4697" stopColor="#35C765" />
        <stop offset="0.5" stopColor="#00C480" />
        <stop offset="0.67" stopColor="#00A1FB" />
        <stop offset="0.704" stopColor="#0F93F8" />
        <stop offset="0.7699" stopColor="#3870F1" />
        <stop offset="0.8604" stopColor="#7936E4" />
        <stop offset="0.87" stopColor="#8030E3" />
        <stop offset="1" stopColor="#8030E3" />
      </linearGradient>
      <clipPath id="clip0_1761_3481">
        <rect width="86" height="35" fill="white" transform="translate(0.449402 0.42334)" />
      </clipPath>
    </defs>
  </svg>
);

// eslint-disable-next-line import/no-default-export
export default SVGStuff;
